import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useEffect, useState } from "react";

const BasicDropdown = ({
  label,
  data = [],
  initValue,
  onValueChange = () => {},
  addNoSelectionOption = true,
  disabled,
}) => {
  const [selectedId, setSelectedId] = useState("");

  // Keep only the `id` as selected value
  useEffect(() => {
    if (initValue && initValue.id !== undefined) {
      setSelectedId(initValue.id);
    } else {
      setSelectedId("");
    }
  }, [initValue]);

  const handleChange = (event) => {
    const id = event.target.value;
    setSelectedId(id);
    const selectedItem = data.find((item) => item.id === id) || null;
    onValueChange(event, selectedItem);
  };

  return (
    <FormControl fullWidth disabled={disabled}>
      <InputLabel id="select-label" shrink>
        {label}
      </InputLabel>
      <Select
        labelId="select-label"
        value={selectedId}
        label={label}
        onChange={handleChange}
        displayEmpty
        renderValue={(selected) => {
          if (!selected) return <em>No Selection</em>;
          const selectedItem = data.find((item) => item.id === selected);
          return selectedItem?.label || "";
        }}
      >
        {addNoSelectionOption && (
          <MenuItem value="">
            <em>No Selection</em>
          </MenuItem>
        )}
        {data.map((menuItem) => (
          <MenuItem key={menuItem.id} value={menuItem.id}>
            {menuItem.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default BasicDropdown;
